<div [ngClass]="{ 'input-group-sm': small_input, 'input-group': true }">
  <input
    [(ngModel)]="stylesheetSearchTerm"
    type="text"
    [appAutocomplete]="'/stylesheets/autocomplete_stylesheet_name'"
    [data]="params"
    [include_item]="include_item"
    (autocompleteSelect)="stylesheetSearchOnSelect($event)"
    [placeholder]="placeholder || 'Search for stylesheet'"
    class="form-control"
    [disabled]="!select_only && (!!stylesheetId || !editable)"
    name="stylesheet-search"
    ngDefaultControl
  />
  <div class="input-group-append" *ngIf="!select_only">
    <button type="button" class="btn btn-primary" [disabled]="!stylesheetId || !editable" (click)="clearSelectedStylesheet()">
      <span class="fas fa-pencil-alt"></span>
    </button>
  </div>
</div>
